var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?[_c('div',{staticClass:"d-flex vertical-center justify-content-center align-items-center",staticStyle:{"height":"50vh","display":"flex"}},[_c('LoadingMDL')],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }